import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithReAuth } from './base-query'
import type { OkResponse } from './types/common'
import type {
	CreateDealTaskBody,
	DealTask,
	ListDealTasksParams,
	ListDealTasksResponse,
	UpdateDealTaskBody,
} from './types/deal'

export const dealTasksApi = createApi({
	reducerPath: 'dealTasksApi',
	baseQuery: baseQueryWithReAuth,
	tagTypes: ['DealTask'],
	endpoints: (builder) => ({
		listDealTasks: builder.query<ListDealTasksResponse, ListDealTasksParams>({
			query: ({ dealId, ...params }) => ({
				url: `/crm/deals/${dealId}/tasks`,
				params,
			}),
			providesTags: (_r, _e, { dealId }) => [{ type: 'DealTask', id: dealId }],
		}),

		createDealTask: builder.mutation<
			DealTask | null,
			{ dealId: string; body: CreateDealTaskBody }
		>({
			query: ({ dealId, body }) => ({
				url: `/crm/deals/${dealId}/tasks`,
				method: 'POST',
				body,
			}),
			invalidatesTags: (_r, _e, { dealId }) => [{ type: 'DealTask', id: dealId }],
		}),

		updateDealTask: builder.mutation<
			DealTask | null,
			{ dealId: string; taskId: string; body: UpdateDealTaskBody }
		>({
			query: ({ dealId, taskId, body }) => ({
				url: `/crm/deals/${dealId}/tasks/${taskId}`,
				method: 'PATCH',
				body,
			}),
			invalidatesTags: (_r, _e, { dealId }) => [{ type: 'DealTask', id: dealId }],
		}),

		deleteDealTask: builder.mutation<OkResponse, { dealId: string; taskId: string }>({
			query: ({ dealId, taskId }) => ({
				url: `/crm/deals/${dealId}/tasks/${taskId}`,
				method: 'DELETE',
			}),
			invalidatesTags: (_r, _e, { dealId }) => [{ type: 'DealTask', id: dealId }],
		}),
	}),
})

export const {
	useListDealTasksQuery,
	useCreateDealTaskMutation,
	useUpdateDealTaskMutation,
	useDeleteDealTaskMutation,
} = dealTasksApi
